import { Component } from '@angular/core'

import { ApiActivitiesService } from '../data/services/api/api-activities.service'
import { ITableCol } from '@data/interfaces/itable.interface'

@Component({
  selector: 'app-funnel-tasks',
  templateUrl: './funnel-tasks.component.html',
  styleUrls: ['./funnel-tasks.component.scss'],
})
export class FunnelTasksComponent {
  detailVisible = false
  selectedId: string | null = null

  columns: ITableCol[] = [
    { type: 'text', field: 'title', header: 'Tarea' },
    { type: 'text', field: 'client.name', header: 'Cliente' },
    { type: 'text', field: 'state', header: 'Estado' },
    { type: 'date', field: 'createdAt', header: 'Creada', dataType: 'date' },
  ]

  actions = [{ icon: 'fa-solid fa-eye', color: 'info', action: 'view', title: 'Ver detalle' }]

  constructor(public apiService: ApiActivitiesService) {}

  onAction(event: { action: string; data: any }): void {
    if (event.action === 'view') {
      this.selectedId = event.data._id
      this.detailVisible = true
    }
  }

  onTaskChanged(): void {
    //* tras cambiar estado, el detalle re-hidrata por su cuenta; la bandeja se refresca al re-abrir.
  }
}
